import { Injectable } from '@angular/core';
import { CoveragePremiumCoverageInterface } from '@app/core/interfaces';

/** @deprecated use outshared-lib - InsurancePolicyDataService */
@Injectable({ providedIn: 'root' })
export class CalculationTransformService {
    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public mapCoveragesToFutureState(props: {
        purchased_coverages: CoveragePremiumCoverageInterface[];
        start_date: string;
        coverage_ids: {
            coverage_id: string;
        }[];
    }): CoveragePremiumCoverageInterface[] {
        const { purchased_coverages, coverage_ids, start_date } = props;
        const coverages: CoveragePremiumCoverageInterface[] = [];

        purchased_coverages.forEach((coverage) => {
            if (coverage.purchased_coverage) {
                coverages.push(this.mapPurchasedToFutureState(coverage_ids, coverage, start_date));
            } else {
                coverages.push(this.mapFuturePurchasedToFutureState(coverage_ids, coverage, start_date));
            }
        });

        return coverages;
    }

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    public mapCoveragesToCurrentState(
        purchasedCoverages: CoveragePremiumCoverageInterface[],
    ): CoveragePremiumCoverageInterface[] {
        const coverages: CoveragePremiumCoverageInterface[] = purchasedCoverages.reduce(
            (previousValue: CoveragePremiumCoverageInterface[], currentValue: CoveragePremiumCoverageInterface) => {
                return [...previousValue, this.mapToCurrentState({ ...currentValue })];
            },
            [],
        );

        return coverages;
    }

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    private mapPurchasedToFutureState(
        coverage_ids: { coverage_id: string }[],
        coverage: CoveragePremiumCoverageInterface,
        start_date: string,
    ): CoveragePremiumCoverageInterface {
        const isPurchased: boolean = this.isPurchased(coverage_ids, coverage.coverage_id);

        if (isPurchased) {
            return {
                ...coverage,
                purchased_coverage: {
                    ...coverage.purchased_coverage,
                    validity_status_code: 'ACTI',
                    end_date: null,
                },
                purchased_coverage_future: null,
            };
        } else {
            return {
                ...coverage,
                purchased_coverage: {
                    ...coverage.purchased_coverage,
                    validity_status_code: 'ACEI',
                    end_date: start_date,
                },
                purchased_coverage_future: null,
            };
        }
    }

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    private mapFuturePurchasedToFutureState(
        coverage_ids: { coverage_id: string }[],
        coverage: CoveragePremiumCoverageInterface,
        start_date: string,
    ): CoveragePremiumCoverageInterface {
        const isPurchased: boolean = this.isPurchased(coverage_ids, coverage.coverage_id);

        if (isPurchased) {
            return {
                ...coverage,
                purchased_coverage: null,
                purchased_coverage_future: {
                    ...coverage.purchased_coverage_future,
                    validity_status_code: 'TOEK',
                    start_date,
                    end_date: null,
                },
            };
        } else {
            return {
                ...coverage,
                purchased_coverage: null,
                purchased_coverage_future: null,
            };
        }
    }

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    private mapToCurrentState(coverage: CoveragePremiumCoverageInterface): CoveragePremiumCoverageInterface {
        const newCoverage = Object.assign({}, coverage);

        if (newCoverage.purchased_coverage?.end_date) {
            const purchasedCoverage = { ...newCoverage.purchased_coverage };

            purchasedCoverage.end_date = null;
            purchasedCoverage.validity_status_code = 'ACTI';

            newCoverage.purchased_coverage = purchasedCoverage;
        }

        if (coverage.purchased_coverage_future) {
            newCoverage.purchased_coverage_future = null;
        }

        return newCoverage;
    }

    /** @deprecated use outshared-lib - InsurancePolicyDataService */
    private isPurchased(coverage_ids: { coverage_id: string }[], coverage_id: string): boolean {
        const foundCoverage = coverage_ids.find((coverage) => coverage.coverage_id === coverage_id);
        return Boolean(foundCoverage);
    }
}
